export default {
  en: {
    title: 'Suppliers',
    pageTitle: 'Suppliers - {0}',
    pageHeader: 'Suppliers',
    entityName: 'Supplier',
    dataTableColumns: {
      supplier: 'Supplier name',
      compliance: 'Compliance',
      approvalStatus: 'Approval status',
      criticality: 'Criticality',
      confidentiality: 'Confidentiality',
      holdsPII: 'PII',
      labels: 'Labels',
      products: 'Products',
      assignedUsers: 'Assigned',
      policiesApplied: 'Policies applied',
      dateAdded: 'Date added',
      companyNumber: 'Company number',
      country: 'Country',
      managed: 'RL managed',
      assessmentProgress: 'Assessment progress',
      lastUpdatedAt: 'Last answer updated',
      sector: 'Sector',
      website: 'Website',
      exemptionsApplied: 'Exemptions applied',
      nonComplianceApplied: 'Non-compliance applied',
      remediationRequests: 'Remediation requests',
      remediationResponses: 'Remediation responses',
      evidence: 'Evidence',
      activeDiscussions: 'Active discussions',
      archivedDiscussions: 'Archived discussions',
      invitedAt: 'Date invited',
      invitedBy: 'Invite sender',
      inviteEmail: 'Invite email',
      approvalExpiresAt: 'Approval expiry',
      reassessmentNextDueAt: 'Next re-assessment due',
      latestAssessmentProgressPercentage: 'Assessment progress',
      numRisks: 'Open risks',
      lastAssessmentDate: 'Last assessment',
      federatedMutualConnections: 'Federated shared connections',
      connectionProfileTypeResolved: 'Profile type',
      connectionProfileTypeUnclaimed: 'Unclaimed',
      connectionProfileTypeBasic: 'Basic access',
      connectionProfileTypeFull: 'Full access',
      connectionProfileTypeManaged: 'RL managed',
      connectionStatus: 'Connection status',
      approvalReviewers: 'Reviewers',
    },
    dataTableColumnsTooltips: {
      lastAssessmentDateOverdue: 'Supplier re-assessment overdue',
      lastAssessmentDateIncomplete: 'Supplier assessment incomplete',
    },
    dataTable: {
      managedLabel: 'RL managed',
      managedDescription: 'This profile has been created and is managed by Risk Ledger.',
      incomplete: 'Incomplete',
      filterResultsSuppliers: '{count} suppliers | {count} supplier | {count} suppliers',
      filterResultsOutOf: '{0} out of {1}',
      deletedUser: 'Deleted user',
      communityPeers: '{n} peer | {n} peers',
      inviteSend: 'Invite sent',
      sendRequest: 'Send request',
      sendInvite: 'Send invite',
      sendConnectionRequest: 'Request access',
      notInvited: 'Not invited',
      notConnected: 'Not connected',
      connectionStatusAccepted: 'Connected',
      connectionStatusPending: 'Pending',
      connectionStatusRejected: 'Rejected',
      connectionStatusRemoved: 'Removed',
      CONNECTION_STATUS_REQUEST_PENDING: 'Pending',
      CONNECTION_STATUS_CONNECTED: 'Connected',
      CONNECTION_STATUS_NOT_CONNECTED: 'Not connected',
      CONNECTION_STATUS_REQUEST_REJECTED: 'Rejected',
      CONNECTION_STATUS_REMOVED: 'Removed',
      CONNECTION_STATUS_INVITED: 'Invited',
      CONNECTION_STATUS_NOT_INVITED: 'Not invited',
    },
    filterAttributes: {
      searchPlaceholder: 'Search suppliers...',
      name: 'Name',
      companyNumber: 'Company number',
      website: 'Website',
      country: 'Country',
      product: 'Product',
      lastActiveAt: 'Last answer updated',
      managed: 'RL managed',
      managedTrue: 'is managed',
      managedFalse: 'is not managed',
      percentageCompliance: 'Compliance',
      criticality: 'Criticality',
      confidentiality: 'Confidentiality',
      holdsPII: 'Holds PII',
      approvalStatus: 'Approval status',
      assignedToMeForApprovalReview: 'Reviews assigned to me',
      assignedToMeForApprovalReviewTrue: 'is assigned to me for reviews',
      assignedToMeForApprovalReviewFalse: 'is not assigned to me for reviews',
      approvalReviewers: 'Reviewers',
      approved: 'Approved',
      rejected: 'Rejected',
      removed: 'Removed',
      pending_biz: 'Pending business',
      approvedExpiry: 'Approval expired',
      inreview: 'In review',
      unapproved: 'Unapproved',
      approvalModifiedAt: 'Approval last modified',
      approvalExpiresAt: 'Approval expiry',
      numPoliciesApplied: 'Number of policies applied',
      createdAt: 'Date added',
      labels: 'Labels',
      sectorID: 'Sector',
      assignedUsers: 'Assigned users',
      numActiveDiscussions: 'Number of active discussions',
      numArchivedDiscussions: 'Number of archived discussions',
      numExemptionsApplied: 'Number of exemptions applied',
      numNonComplianceApplied: 'Number of non compliances applied',
      numRemediationRequests: 'Number of remediation requests',
      numRemediationResponses: 'Number of remediation responses',
      numEvidence: 'Number of evidence',
      assignedToMe: 'Assigned to me',
      assignedToMeTrue: 'is assigned to me',
      assignedToMeFalse: 'is not assigned to me',
      invitedAt: 'Date invited',
      invitedBy: 'Invite sender',
      inviteEmail: 'Invite email',
      reassessmentNextDueAt: 'Next re-assessment due',
      numRisks: 'Open risks',
      lastAssessmentDate: 'Last assessment date',
      assessmentProgress: 'Assessment progress',
      assessmentComplete: 'Assessment complete',
      assessmentCompleteTrue: 'True',
      assessmentCompleteFalse: 'False',
      reassessmentOverdue: 'Reassessment overdue',
      reassessmentOverdueTrue: 'True',
      reassessmentOverdueFalse: 'False',
      federatedMutualConnections: 'Federated shared connections',
      profileTypeResolved: 'Supplier',
      profileTypeResolvedClaimed: 'Not unclaimed',
      profileTypeResolvedUnclaimed: 'Unclaimed',
      connectionProfileTypeResolved: 'Profile type',
      connectionProfileTypeUnclaimed: 'Unclaimed',
      connectionProfileTypeBasic: 'Basic access',
      connectionProfileTypeFull: 'Full access',
      connectionProfileTypeManaged: 'RL managed',
      connected: 'Connected',
      notConnected: 'Not connected',
      pending: 'Pending',
      inviteSent: 'Invite sent',
      notInvited: 'Not invited',
    },
    saveModal: {
      title: 'Save a new view',
      save: 'Save view',
      saveNew: 'Save as new view',
      saveExisting: 'Update existing view',
      updateError: 'There was an error updating the view',
      cancel: 'Cancel',
      description:
        'Give your view a name below. Once saved, it will appear in the sidebar for you and your colleagues.',
      placeholder: 'Name of view...',
    },
    editName: {
      title: "Rename view '{name}'",
      description: 'Give your view a new name below.',
      placeholder: 'Name of view...',
      cancel: 'Cancel',
      save: 'Save view',
      renameError: 'There was an error renaming the view',
    },
    deleteModal: {
      buttonAlt: 'Delete view',
      title: "Delete view '{0}'?",
      description:
        "Please confirm if you would like to remove the '{0}' view. It will no longer appear in the sidebar for you and your colleagues.",
      delete: 'Delete view',
      cancel: 'Cancel',
      failed: 'Deleting the view failed.',
    },
    placeholders: {
      emptyTitle: 'Suppliers',
      emptyDescription: 'No connections could be found',
      errorTitle: 'Suppliers',
      errorDescription: 'Failed fetching connections',
    },
    export: 'Export',
    exportError: 'There was an error attempting to export the current view',
  },
};
